import { connect } from 'react-redux'

import { addItemToCart } from '../../../../common/actions/user/cart'
import CheckoutForm from './checkoutForm'

const mapDispatchToProps = dispatch => {
  return { addItemToCart: data => dispatch(addItemToCart(data)) }
}

const mapStateToProps = (state, ownProps) => {
  const { user: { cart } } = state
  const { common: { currentSite } } = state

  return {
    cartEntries: cart && cart.entries,
    currentSite: currentSite
  }
}

const CheckoutFormContainer = connect(mapStateToProps, mapDispatchToProps)(
  CheckoutForm
)

export default CheckoutFormContainer
